export default "__VITE_ASSET__Ds35L2D0__"